<script>
/**
 * Mixin for filter and sorting options of the dashboard
 */

import mixinActionsOptions from '@/mixins/page-options/actions.vue';
import mixinIdcOptions from '@/mixins/page-options/indicators.vue';
import mixinInfosOptions from '@/mixins/page-options/infos.vue';
import mixinProblemOptions from '@/mixins/page-options/problems.vue';

export default {

  mixins: [mixinActionsOptions, mixinIdcOptions, mixinInfosOptions],

  computed: {
    dashboardOptions() {
      return [
        {
          key: 'dbtext1',
          value: '',
          component: 'h2',
          options: { class: 'mt5em mb5em basic-sub-title' },
          slots: [{
            component: 'div',
            content: this.$t('message.INDICATORS'),
          }],
        },
        ...this.idcOptions,
        {
          key: 'dbsep1',
          component: 'Div',
          options: { class: 'sep sep--centered' },
        },
        {
          key: 'dbtext2',
          value: '',
          component: 'h2',
          options: { class: 'mt5em mb5em basic-sub-title' },
          slots: [{
            component: 'div',
            content: this.$t('message.ACTIONS'),
          }],
        },
        ...this.actOptions,
        {
          key: 'dbsep2',
          component: 'Div',
          options: { class: 'sep sep--centered' },
        },
        {
          key: 'dbtext3',
          value: '',
          component: 'h2',
          options: { class: 'mt5em mb5em basic-sub-title' },
          slots: [{
            component: 'div',
            content: this.$t('message.PROBLEMS'),
          }],
        },
        ...this.pbOptions,
        {
          key: 'dbsep3',
          component: 'Div',
          options: { class: 'sep sep--centered' },
        },
        {
          key: 'dbtext4',
          value: '',
          component: 'h2',
          options: { class: 'mt5em mb5em basic-sub-title' },
          slots: [{
            component: 'div',
            content: this.$t('message.INFORMATIONS'),
          }],
        },
        ...this.infosOptions,
      ];
    },
  },

  methods: {
    /** Create a string formatted as query params with infosOptions params */
    dashboardOptQueryParams(options) {
      const queries = [];
      queries.push(this.infosOptQueryParams(options));
      queries.push(this.actOptQueryParams(options));
      queries.push(this.idcOptQueryParams(options));
      queries.push(this.pbOptQueryParams(options));
      return queries
        .filter(q => q.length > 0)
        .join('&');
    },
  },
};
</script>
